/* eslint-disable @typescript-eslint/naming-convention */
import { get } from '@core/api/baseApi';

const getOrganizationSettings = (organizationId: string | undefined): Promise<any> => 
  get(`/organizations/${organizationId}/settings`);
  

export { getOrganizationSettings };
